<section [class]="'mx-auto px-4 sm:px-6 lg:px-0 ' + dir">

    <section class="lg:container lg:mx-auto py-5 lg:px-8 lg:py-32">
        <h2 class="text-center text-white lg:text-4xl text-2xl font-semibold mb-3">{{"DEMO.HOWIT"|translate}} <span
                class="text-primary">{{"DEMO.WORKS"|translate}}</span>
        </h2>
        <div class="relative flex text-center mx-auto  justify-center ">
            <p class="absolute  text-white z-10  lg:mt-96 md:mt-64 mt-28">{{"DEMO.LEARNHOW"|translate}}</p>
        </div>
        <!--  Youtube UI starts here  -->
        <figure class="relative flex justify-center">
            <!-- <img src="../../../../assets/img_demo.png" alt="demo" />
            <a class="absolute place-self-center md:mt-36 mt-10 w-5 md:w-auto hover:cursor-pointer"><img
                    src="../../../../assets/icon_play.png" alt="play" /></a> -->
            <div class="w-full mx-auto mt-3 demo_video_blk">
                <app-youtube-player videoUrl="https://youtu.be/x2rhUhp41k0"></app-youtube-player>
            </div>
        </figure>
    </section>
</section>

